// src/pages/IsoMeetingsHome.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const IsoMeetingsHome = () => {
  const navigate = useNavigate();

  const [loadingUser, setLoadingUser] = useState(true);
  const [username, setUsername] = useState("");
  const [systemRole, setSystemRole] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) {
          setError("You must be logged in.");
          setLoadingUser(false);
          return;
        }
        const res = await axios.get("/api/users/me/", {
          headers: { Authorization: `Bearer ${token}` },
        });

        const uname = res.data.username || "";
        const srole = res.data.system_role || "";

        setUsername(uname);
        setSystemRole(srole);

        // keep in localStorage for consistency
        localStorage.setItem("username", uname);
        localStorage.setItem("system_role", srole);
      } catch (err) {
        console.error("Error loading current user:", err);
        setError("Unable to load user details.");
      } finally {
        setLoadingUser(false);
      }
    };

    fetchMe();
  }, []);

  const handleSendInvite = () => {
    navigate("/meetings/invite");
  };

  const handleViewMeetings = () => {
    navigate("/meetings/list");
  };

  if (loadingUser) {
    return (
      <div style={styles.page}>
        <div style={styles.loadingBox}>Loading user details...</div>
      </div>
    );
  }

  // If not Head → block
  if (systemRole !== "Head") {
    return (
      <div style={styles.page}>
        <div style={styles.deniedBox}>
          <h2 style={{ marginBottom: 10 }}>Access Restricted</h2>
          <p>
            The <strong>ISO Mandated Meetings</strong> module is only available
            to users with the <strong>Head</strong> system role.
          </p>
          <button style={styles.backBtn} onClick={() => (window.location.href = "/dashboard")}>
            ⬅ Back to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.page}>
      {/* Header */}
      <div style={styles.headerRow}>
        <h1 style={styles.title}>ISO Mandated Meetings</h1>
        <button
          style={styles.backBtn}
          onClick={() => (window.location.href = "/dashboard")}
        >
          ⬅ Back to Dashboard
        </button>
      </div>

      {/* User Chip */}
      <div style={styles.userRow}>
        <span>
          <strong>User:</strong>{" "}
        </span>
        <span style={styles.userChip}>{username || "Unknown"}</span>
        <span style={{ marginLeft: 10 }}>
          <strong>Role:</strong>{" "}
        </span>
        <span style={styles.roleChip}>{systemRole || "N/A"}</span>
      </div>

      {/* Cards Row */}
      <div style={styles.cardsRow}>
        <div
          style={styles.card}
          onClick={handleSendInvite}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-8px)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
        >
          
          <h2 style={styles.cardTitle}>Send Meeting Invite</h2>
          <p style={styles.cardText}>
            Create a new ISO mandated meeting and send email invitations to
            selected users of your company.
          </p>
        </div>

        <div
          style={styles.card}
          onClick={handleViewMeetings}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-8px)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
        >
          
          <h2 style={styles.cardTitle}>Previous Meetings</h2>
          <p style={styles.cardText}>
            View the list of past meetings and see which users were invited
            from your company.
          </p>
        </div>
      </div>

      {error && <div style={styles.errorBox}>{error}</div>}
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    padding: "30px",
    background: "linear-gradient(135deg, #f6f8fc, #e4ebff)",
    fontFamily: "Segoe UI, Roboto, sans-serif",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    fontWeight: 700,
    color: "#1f2933",
    margin: 0,
  },
  backBtn: {
    backgroundColor: "#6b7280",
    color: "#fff",
    border: "none",
    padding: "8px 14px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 14,
  },
  userRow: {
    marginBottom: 20,
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  userChip: {
    background: "#eef2ff",
    padding: "4px 10px",
    borderRadius: 999,
  },
  roleChip: {
    background: "#dcfce7",
    padding: "4px 10px",
    borderRadius: 999,
  },
  cardsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
    gap: 20,
    marginTop: 10,
  },
  card: {
    background: "#ffffff",
    borderRadius: 16,
    padding: 24,
    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.08)",
    cursor: "pointer",
    transition: "transform 0.25s ease, box-shadow 0.25s ease",
  },
  iconCircle: {
    width: 46,
    height: 46,
    borderRadius: "50%",
    background: "#eef2ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 24,
    marginBottom: 12,
  },
  cardTitle: {
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 8,
  },
  cardText: {
    fontSize: 14,
    color: "#4b5563",
  },
  loadingBox: {
    marginTop: 100,
    textAlign: "center",
    fontSize: 18,
    color: "#4b5563",
  },
  deniedBox: {
    margin: "80px auto",
    maxWidth: 500,
    background: "#fff",
    borderRadius: 16,
    padding: 24,
    textAlign: "center",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
  },
  errorBox: {
    marginTop: 16,
    padding: 10,
    borderRadius: 8,
    background: "#fee2e2",
    color: "#991b1b",
  },
};

export default IsoMeetingsHome;
